@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  :root {
    --background: 0 0% 100%;
    --foreground: 222.2 84% 4.9%;
  }
  
  body {
    @apply bg-white text-gray-900;
    font-feature-settings: "rlig" 1, "calt" 1;
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Animation utilities */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-fade-in {
  animation: fadeIn 0.3s ease-out;
}

.animate-slide-in {
  animation: slideIn 0.3s ease-out;
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* Hide scrollbar utility */
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* Line clamp utility */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Device frame styles */
.device-frame {
  transition: all 0.3s ease;
}

.device-frame-mobile {
  width: 375px;
  border: 8px solid #1f2937;
  border-radius: 24px;
}

.device-frame-tablet {
  width: 768px;
  border: 12px solid #1f2937;
  border-radius: 16px;
}

.device-frame-desktop {
  width: 100%;
}

/* Markdown content styles */
.prose pre {
  @apply bg-gray-900 text-gray-100 p-4 rounded-lg overflow-x-auto my-3;
}

.prose code {
  @apply font-mono text-sm;
}

.prose p {
  @apply mb-3 last:mb-0;
}

.prose ul, .prose ol {
  @apply mb-3 pl-5;
}

.prose li {
  @apply mb-1;
}

.prose h1, .prose h2, .prose h3, .prose h4 {
  @apply font-bold mb-3 mt-4 first:mt-0;
}

.prose h1 {
  @apply text-xl;
}

.prose h2 {
  @apply text-lg;
}

.prose h3 {
  @apply text-base;
}

.prose blockquote {
  @apply border-l-4 border-purple-300 pl-4 italic my-3;
}

.prose a {
  @apply text-purple-600 underline hover:text-purple-800;
}

.prose table {
  @apply w-full border-collapse my-3;
}

.prose th, .prose td {
  @apply border border-gray-300 px-3 py-2 text-left;
}

.prose th {
  @apply bg-gray-100 font-semibold;
}

/* Prose invert for user messages */
.prose-invert pre {
  @apply bg-gray-800;
}

.prose-invert code {
  @apply bg-white/20 text-white;
}

.prose-invert blockquote {
  @apply border-white/30;
}

.prose-invert a {
  @apply text-white/90;
}

.prose-invert th {
  @apply bg-white/10;
}

.prose-invert td, .prose-invert th {
  @apply border-white/20;
}
